import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';

import { ClientService } from '../../services/client.service';
import { UserService } from '../../services/user.service';
import { ToastComponent } from '../../shared/toast/toast.component';
import { setClassInvalid } from '../../shared/functions';
import { categories, clusters, ee, urlRegexp, usernameRegexp } from '../../shared/constants';
import { finalize } from 'rxjs';

@Component({
  selector: 'app-add-client-form',
  templateUrl: './add-client-form.component.html',
  standalone: false
})
export class AddClientFormComponent implements OnInit, OnDestroy {
  private clientService = inject(ClientService);
  private userService = inject(UserService);
  private formBuilder = inject(UntypedFormBuilder);
  toast = inject(ToastComponent);


  addClientForm = this.createClientForm();
  directorLastNames = '';
  clusters = clusters;
  categories = categories;
  usernameRegexp = usernameRegexp;
  urlRegexp = urlRegexp;
  setClassInvalid = setClassInvalid;

  ngOnInit(): void {
    ee.on('searchInput', (obj: any) => this.addClientForm.patchValue(obj));
    this.getDirectors();
  }

  ngOnDestroy(): void {
    ee.off('searchInput', () => {});
  }

  getDirectors(): void {
    this.userService.getDirectors()
      .subscribe({
        next: res => this.directorLastNames = res.map(user => user.lastName)?.join(', '),
        error: err => this.toast.setMessage(err.error.message, 'danger'),
      });
  }

  createClientForm(): UntypedFormGroup {
    return this.formBuilder.group({
      name: ['', Validators.required],
      image: [''],
      website: ['', Validators.compose([Validators.pattern(/^https?:\/\/.*/), Validators.required])],
      driveurl: ['', Validators.compose([Validators.pattern(/^https?:\/\/.*/), Validators.required])],
      cluster: ['', Validators.required],
      category: [''],
      contracts: [[]],
      notes: [''],
      _users: [[]], // used for permissions (user._clients) here, but used for coordinators in db and edit client
      socials: this.formBuilder.group({
        twitter: this.formBuilder.group({
          username: ['', Validators.pattern(usernameRegexp.twitter)]
        }),
        instagram: this.formBuilder.group({
          username: ['', Validators.pattern(usernameRegexp.instagram)]
        }),
        facebook: this.formBuilder.group({
          username: ['', Validators.pattern(usernameRegexp.facebook)]
        }),
        linkedin: this.formBuilder.group({
          username: ['', Validators.pattern(usernameRegexp.linkedin)]
        })
      })
    });
  }

  addClient(): void {
    this.clientService.add(this.addClientForm.value)
      .pipe(finalize(() => {
        ee.emit('getClients');
        ee.emit('clientAdded', true);
      }))
      .subscribe({
        next: res => this.toast.setMessage('Client added successfully!', 'success'),
        error: err => this.toast.setMessage(err.error.message, 'danger')
      });
  }
}
